import React from "react";

/**
 * Header, completion indicator, inline actions, and desktop sticky action bar.
 */
const ProductFormChrome = ({
  title,
  subtitle,
  completion = 0,
  loading = false,
  savingDraft = false,
  onSaveDraft,
  onPublish,
  extraActions = null,
  publishLabel = "Publish Product",
  publishingLabel = "Publishing…",
}) => {
  const busy = loading || savingDraft;

  return (
    <>
      <div className="oms-header product-form-page__header">
        <div className="product-form-page__title-wrap">
          <h1 className="dashboard-title">{title}</h1>
          {subtitle && (
            <p className="product-form-page__subtitle">{subtitle}</p>
          )}
          <div className="product-form-page__completion" aria-live="polite">
            <div className="product-form-page__completion-label">
              <span>Product Completion</span>
              <span className="product-form-page__completion-value">
                {completion}%
              </span>
            </div>
            <div
              className="product-form-page__completion-track"
              role="progressbar"
              aria-valuenow={completion}
              aria-valuemin={0}
              aria-valuemax={100}
              aria-label={`Product completion ${completion} percent`}
            >
              <div
                className="product-form-page__completion-fill"
                style={{ width: `${completion}%` }}
              />
            </div>
          </div>
        </div>
        <div className="product-form-page__header-actions">
          {extraActions}
          {busy ? (
            <button type="button" className="product-form-page__btn-draft" disabled>
              {savingDraft ? "Saving draft…" : publishingLabel}
            </button>
          ) : (
            <>
              <button
                type="button"
                className="product-form-page__btn-draft"
                onClick={onSaveDraft}
              >
                Save Draft
              </button>
              <button
                type="button"
                className="oms-add-btn"
                onClick={onPublish}
              >
                {publishLabel}
              </button>
            </>
          )}
        </div>
      </div>

      <div className="product-form-page__sticky-bar" aria-hidden={busy}>
        <div className="product-form-page__sticky-inner">
          <span className="product-form-page__sticky-completion">
            {completion}% complete
          </span>
          <div className="product-form-page__sticky-actions">
            {busy ? (
              <button type="button" className="product-form-page__btn-draft" disabled>
                {savingDraft ? "Saving draft…" : publishingLabel}
              </button>
            ) : (
              <>
                <button
                  type="button"
                  className="product-form-page__btn-draft"
                  onClick={onSaveDraft}
                >
                  Save Draft
                </button>
                <button
                  type="button"
                  className="oms-add-btn product-form-page__btn-publish"
                  onClick={onPublish}
                >
                  {publishLabel}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductFormChrome;
